<template>
  <div>
    <v-row>
      <v-col :cols="12">
        <v-text-field
          class="mx-4"
          label="Description"
          v-model="name"
        ></v-text-field>
      </v-col>
      <v-col :cols="12">
        <v-text-field
          class="mx-4"
          label="Amount"
          v-model="amount"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row class="mx-4 mb-4">
      <v-col :cols="12">
        <v-btn dark large block color="success" @click="createSalary()"
          ><v-icon>mdi-plus</v-icon>Create Salary</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
import mainJs from "../main";

export default {
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    getCreateSalaryRoute() {
      return this.$store.getters.getCreateSalaryRoute;
    },
  },
  data: () => ({
    amount: 0,
    name: "Basic Salary",
  }),
  methods: {
    async createSalary() {
      this.$store.commit("setLoader", true);

      const salary = await mainJs.createSalary(
        this.getApiUrl + this.getCreateSalaryRoute,
        this.name,
        mainJs.stripCommasFromMoney(this.amount),
        this.getAccessToken
      );
      this.$toast.success("Salary Created Successfully!", { duration: 3000 });
      this.$emit("salary-created", salary);
      this.$store.commit("setLoader", false);
    },
  },
};
</script>

<style></style>
